export class Expense
{
	expenseId: number;
	expenseDate: Date;
	workOrderCreateDate: any;
	completedDate: any;
	scheduledDateTime: any;
	startDateTime: any;
	vendorUpdateDateTime: any;
	stmtBilledDate: any;
	lastUpdate: Date;
	createDate: Date;
}
